module.exports = __webpack_public_path__ + "img/zoom-in.fc867a8c.svg";